export function isNumeric(value: any): value is string | number {
  if (!value) {
    return value === 0;
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    return false;
  }

  return isFinite(+value);
}

// Ref: https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
export const roundTo = (n: number, digits: number) => {
  const multiplier = 10 ** digits;
  return Math.round(n * multiplier * (1 + Number.EPSILON)) / multiplier;
};

export const floorTo = (n: number, digits: number) => {
  if (n < 0) {
    return -ceilTo(-n, digits);
  }

  const multiplier = 10 ** digits;
  return Math.floor(n * multiplier * (1 + Number.EPSILON)) / multiplier;
};
export const ceilTo = (n: number, digits: number) => {
  if (n < 0) {
    return -floorTo(-n, digits);
  }

  const multiplier = 10 ** digits;
  return Math.ceil(n * multiplier * (1 - Number.EPSILON)) / multiplier;
};

// NOTE the toNominal and toEffective logic must match what is on the server. A change need to be done in both places.
export const toNominal = (rate: number) => 365 * (Math.pow(1 + rate, 1 / 365) - 1);

export const toEffective = (rate: number) => Math.pow(1 + rate / 365, 365) - 1;
